import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue";
const _hoisted_1 = {
    key: 0,
    "data-cy": "header-controller",
    class: "header-controller-wrapper"
};
const _hoisted_2 = {
    "data-cy": "header-controller-page-title",
    class: "header-title-text"
};
const _hoisted_3 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (!!_ctx.computedComponent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createCommentVNode(" header controller의 공통 소스 "),
            _createCommentVNode(" <BreadCrumbs></BreadCrumbs> "),
            _createCommentVNode(" 해당 페이지 관련 컨텐츠는 해당 페이지 헤더에.. "),
            (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.computedComponent), {
                    "page-title": _ctx.getterPageTitle[0]
                }, {
                    pageTitle: _withCtx(() => [
                        _createElementVNode("span", _hoisted_2, [
                            _createElementVNode("span", null, [
                                _createTextVNode(_toDisplayString(_ctx.getterPageTitle[0]) + " ", 1 /* TEXT */),
                                (_ctx.getterPageTitle[1])
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_3, " / " + _toDisplayString(_ctx.getterPageTitle[1]), 1 /* TEXT */))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ]),
                    appendPageTitle: _withCtx(() => _cache[0] || (_cache[0] = [])),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["page-title"]))
            ], 1024 /* DYNAMIC_SLOTS */))
        ]))
        : _createCommentVNode("v-if", true);
}
